'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPricetagsOutline = function IoIosPricetagsOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 5h2.5v11.3l-18.7 21.2-2-1.9-1.8 1.9-12.5-12.5 20-22.5h12.5v2.5z m-20 30.7l0.9-0.9 0.9-1 17-19.3v-10.7h-10.8l-18.8 21.2z m21.3-20v-9.4h-1.3v8.7l-17.3 19.8 1.1 0.9z m-8.8-3.2c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z m0-3.7c-0.7 0-1.2 0.5-1.2 1.2s0.5 1.3 1.2 1.3 1.3-0.6 1.3-1.3-0.6-1.2-1.3-1.2z' })
        )
    );
};

exports.default = IoIosPricetagsOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-pricetags-outline.js
// module id = 2283
// module chunks = 0